import { useEffect, useRef } from "react";

/**
 * Invokes a callback when a click happens outside an element. The returned ref must be
 * attached to the element that the click is in refence to.
 * @param callback invoked when clicked on an element that is outside the ref element
 * @returns an HTMLElement ref that should be attached to an element that you want to outside clicks of
 */
export function useOnOutsideClick<T extends HTMLElement>(callback: () => void) {
  const currentCallback = useRef(callback);
  currentCallback.current = callback;

  const containerRef = useRef<T | null>(null);
  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      if (
        e.target instanceof HTMLElement &&
        containerRef.current &&
        !containerRef.current.contains(e.target)
      ) {
        currentCallback.current();
      }
    };

    document.addEventListener("click", onClick);

    return () => {
      document.removeEventListener("click", onClick);
    };
  }, []);

  return containerRef;
}
